import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
  observe,
} from "mobx";
import { act } from "react-dom/test-utils";
import config from "../config";
import Cookies from "js-cookie";

class DeviceLogStore {
  deviceLog = [];

  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      deviceLog: observable,
      total: observable,
      loading: observable,
      loadData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, searchField }) {
    this.loading = true;
    let isadmin = JSON.parse(base64_decode(Cookies.get("data"))).isadmin;
    var postData = {
      searchField: searchField,
      isadmin: isadmin,
      offset: offset,
      limit: limit,
      companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
    };
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/vehicle/deviceLogDetail", {
        params: postData,
      });

    this.deviceLog = response?.data?.data?.vehicleLog;
    // //  this.setCompanies(response?.data?.data?.companydata);
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }
}

export default DeviceLogStore;
